<template>
  <div>
    <b-modal
      id="modal-manifestacao-form"
      @show="Iniciar" @shown="aplicarCor"
      centered
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      :title="titulo"
    >
      <div v-if="etapa === 1">
        <p class="text-muted mb-3">
          <small>Preencha seus dados para registrar sua manifestação. Uma senha de acesso será enviada para o seu e-mail para que você possa acompanhar.</small>
        </p>
        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group label="Nome Completo" label-for="mf-strnome">
              <b-form-input
                id="mf-strnome"
                v-model.trim="form.strnome"
                type="text"
                placeholder="Seu Nome Completo"
                autocomplete="off"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group label="Nome Social (Se possuir)" label-for="mf-strnomesocial">
              <b-form-input
                id="mf-strnomesocial"
                v-model.trim="form.strnomesocial"
                type="text"
                placeholder="Seu Nome Social"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group label="E-mail" label-for="mf-stremail">
              <b-form-input
                id="mf-stremail"
                v-model.trim="form.stremail"
                type="email"
                placeholder="Seu e-mail"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group label="CPF" label-for="mf-strcpf">
              <b-form-input
                id="mf-strcpf"
                v-model.trim="form.strcpf"
                type="tel"
                placeholder="Seu CPF"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group label="Nº de Celular" label-for="mf-strcelular">
              <b-form-input
                id="mf-strcelular"
                v-model.trim="form.strcelular"
                type="tel"
                placeholder="Nº de celular com DDD"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group label="Estado" label-for="mf-intestadoid">
              <b-form-select
                id="mf-intestadoid"
                v-model="form.intestadoid"
                :options="lista_estado"
                @change="ListaCidade()"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group label="Cidade" label-for="mf-intcidadeid">
              <b-form-select
                id="mf-intcidadeid"
                v-model="form.intcidadeid"
                :options="lista_cidade"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <div v-if="etapa === 2">
        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group label="Tipo de Manifestante" label-for="mf-inttipomanifestanteid">
              <b-form-select
                id="mf-inttipomanifestanteid"
                v-model="form.inttipomanifestanteid"
                :options="lista_tipo_manifestante"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group label="Em desfavor de" label-for="mf-inttipoalvoid">
              <b-form-select
                id="mf-inttipoalvoid"
                v-model="form.inttipoalvoid"
                :options="lista_tipo_alvo"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <b-form-group label="Assunto" label-for="mf-intassuntomanifestacaoid">
              <b-form-select
                id="mf-intassuntomanifestacaoid"
                v-model="form.intassuntomanifestacaoid"
                :options="lista_assunto"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group :label="'Descrição - ' + titulo" label-for="mf-strdenuncia">
              <b-form-textarea
                id="mf-strdenuncia"
                v-model.trim="form.strdenuncia"
                placeholder="Descreva aqui sua manifestação..."
                rows="5"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <template #modal-footer="{}">
        <b-button v-if="etapa === 2 && inttipomanifestacaoid !== 6" size="sm" variant="secondary" @click="etapa = 1">
          <b-icon-arrow-left class="mr-2" /> Voltar
        </b-button>
        <b-button v-if="etapa === 1" size="sm" :style="'background-color:' + cor + ';border-color:' + cor" @click="ProximaEtapa()">
          Próximo <b-icon-arrow-right class="ml-2" />
        </b-button>
        <b-button v-if="etapa === 2" size="sm" :style="'background-color:' + cor + ';border-color:' + cor" @click="Enviar()" :disabled="enviando">
          <b-icon-check-circle-fill class="mr-2" />
          {{ enviando ? 'Enviando...' : 'Enviar' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    titulo: { type: String, default: "" },
    cor: { type: String, default: "#198754" },
    inttipomanifestacaoid: { type: Number, default: 1 },
  },
  data() {
    return {
      api: this.$parent.api,
      etapa: 1,
      enviando: false,
      lista_estado: [{ value: null, text: "Selecione uma opção" }],
      lista_cidade: [{ value: null, text: "Selecione o estado primeiro" }],
      lista_tipo_manifestante: [{ value: null, text: "Selecione uma opção" }],
      lista_tipo_alvo: [{ value: null, text: "Selecione uma opção" }],
      lista_assunto: [{ value: null, text: "Selecione uma opção" }],
      form: {
        strnome: null,
        strnomesocial: null,
        stremail: null,
        strcpf: null,
        strcelular: null,
        intestadoid: null,
        intcidadeid: null,
        inttipomanifestanteid: null,
        inttipomanifestacaoid: this.inttipomanifestacaoid,
        inttipoalvoid: null,
        intassuntomanifestacaoid: null,
        strdenuncia: null,
      },
      Toast: this.$swal.mixin({
        toast: true,
        position: "top-end",
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: false,
      }),
    };
  },
  watch: {
    inttipomanifestacaoid(val) {
      this.form.inttipomanifestacaoid = val;
      this.etapa = (val === 6) ? 2 : 1;
    }
  },
  methods: {
    alertaErro(mensagem) {
      this.Toast.fire(mensagem, "", "error");
    },
    cpfValido(strCPF) {
      var Soma, Resto, i;
      Soma = 0;
      if (strCPF == "00000000000") return false;
      for (i = 1; i <= 9; i++) Soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;
      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;
      Soma = 0;
      for (i = 1; i <= 10; i++) Soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;
      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return false;
      return true;
    },
    ProximaEtapa() {
      const filtro_email = /^[a-z0-9][a-z0-9-_.]+@[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,10}$/;
      if (!this.form.strnome || this.form.strnome.length <= 0)
        return this.alertaErro("Preencha o campo Nome Completo");
      if (!this.form.stremail || this.form.stremail.length <= 0)
        return this.alertaErro("Preencha o campo E-mail");
      if (!filtro_email.test(this.form.stremail.toLowerCase()))
        return this.alertaErro("E-mail inválido");
      if (!this.form.strcpf || this.form.strcpf.length <= 0)
        return this.alertaErro("Preencha o campo CPF");
      if (!this.cpfValido(this.form.strcpf.replace(/\D/g, "")))
        return this.alertaErro("CPF inválido");
      if (!this.form.strcelular || this.form.strcelular.length <= 0)
        return this.alertaErro("Preencha o campo Celular");
      if (!this.form.intestadoid)
        return this.alertaErro("Selecione o Estado");
      if (!this.form.intcidadeid)
        return this.alertaErro("Selecione a Cidade");
      this.etapa = 2;
    },
    Enviar() {
      if (!this.form.inttipomanifestanteid)
        return this.alertaErro("Selecione o Tipo de Manifestante");
      if (!this.form.inttipoalvoid)
        return this.alertaErro("Selecione o Tipo de Alvo");
      if (!this.form.intassuntomanifestacaoid)
        return this.alertaErro("Selecione o Assunto");
      if (!this.form.strdenuncia || this.form.strdenuncia.length <= 0)
        return this.alertaErro("Preencha a Descrição");

      this.enviando = true;

      let endpoint = "denuncia/anonima";
      let payload = {};

      if (this.form.inttipomanifestacaoid === 6) {
        endpoint = "denuncia/comunicacao-anonima";
        payload = {
          strdenuncia: this.form.strdenuncia,
          inttipomanifestanteid: this.form.inttipomanifestanteid,
          inttipoalvoid: this.form.inttipoalvoid,
          intassuntomanifestacaoid: this.form.intassuntomanifestacaoid,
        };
      } else {
        payload = {
          strnome: this.form.strnome,
          strnomesocial: this.form.strnomesocial || null,
          stremail: this.form.stremail,
          strcpf: this.form.strcpf.replace(/\D/g, ""),
          strcelular: this.form.strcelular,
          intestadoid: this.form.intestadoid,
          intcidadeid: this.form.intcidadeid,
          strdenuncia: this.form.strdenuncia,
          inttipomanifestanteid: this.form.inttipomanifestanteid,
          inttipomanifestacaoid: this.form.inttipomanifestacaoid,
          inttipoalvoid: this.form.inttipoalvoid,
          intassuntomanifestacaoid: this.form.intassuntomanifestacaoid,
        };
      }

      this.axios
        .post(this.api + endpoint, payload)
        .then((response) => {
          if (response.data) {
            this.$bvModal.hide("modal-manifestacao-form");
            let msg = "Manifestação registrada com sucesso!\nProtocolo: " + response.data.strprotocolo;
            if (this.form.inttipomanifestacaoid !== 6) {
              msg += "\n\nVerifique seu e-mail para obter os dados de acesso e acompanhar sua manifestação.";
            }
            this.$swal("Confirmação", msg, "success");
          }
        })
        .catch((error) => {
          if (error.response) this.alertaErro(error.response.data.erro);
          else this.alertaErro("Ocorreu um erro inesperado, tente novamente!");
        })
        .finally(() => {
          this.enviando = false;
        });
    },
    async ListaEstado() {
      await this.axios.get(this.api + "listar/estado").then((response) => {
        this.lista_estado = [{ text: "Selecione uma opção", value: null }].concat(
          response.data.map((item) => ({ text: item.strestado, value: item.intestadoid }))
        );
      });
    },
    async ListaCidade() {
      this.form.intcidadeid = null;
      this.lista_cidade = [{ value: null, text: "Carregando..." }];
      await this.axios
        .get(this.api + "listar/cidade/" + this.form.intestadoid)
        .then((response) => {
          this.lista_cidade = [{ text: "Selecione uma opção", value: null }].concat(
            response.data.map((item) => ({ text: item.strcidade, value: item.intcidadeid }))
          );
        });
    },
    async ListaTipoManifestante() {
      await this.axios.get(this.api + "listar/interno/tipo_manifestante").then((response) => {
        this.lista_tipo_manifestante = [{ text: "Selecione uma opção", value: null }].concat(
          response.data.map((item) => ({ text: item.strtipomanifestante, value: item.inttipomanifestanteid }))
        );
      }).catch(() => {
        this.lista_tipo_manifestante = [
          { value: null, text: "Selecione uma opção" },
          { value: 1, text: "Assistido/Usuário" },
          { value: 3, text: "Defensor(a)" },
          { value: 4, text: "Servidor(a)" },
          { value: 5, text: "Estagiário(a)" },
          { value: 6, text: "Sociedade Civil" },
          { value: 7, text: "Órgão Públicos" },
        ];
      });
    },
    async ListaTipoAlvo() {
      await this.axios.get(this.api + "listar/interno/tipo_alvo").then((response) => {
        this.lista_tipo_alvo = [{ text: "Selecione uma opção", value: null }].concat(
          response.data.map((item) => ({ text: item.strtipoalvo, value: item.inttipoalvoid }))
        );
      }).catch(() => {
        this.lista_tipo_alvo = [
          { value: null, text: "Selecione uma opção" },
          { value: 1, text: "Defensor(a)" },
          { value: 2, text: "Servidor(a)" },
          { value: 4, text: "Núcleo da DPEMT" },
          { value: 5, text: "Administração Superior" },
          { value: 6, text: "Outros" },
        ];
      });
    },
    async ListaAssunto() {
      await this.axios.get(this.api + "listar/interno/assunto_manifestacao").then((response) => {
        this.lista_assunto = [{ text: "Selecione uma opção", value: null }].concat(
          response.data.map((item) => ({ text: item.strassuntomanifestacao, value: item.intassuntomanifestacaoid }))
        );
      }).catch(() => {
        this.lista_assunto = [
          { value: null, text: "Selecione uma opção" },
          { value: 1, text: "Família" },
          { value: 2, text: "Cível e Sucessões" },
          { value: 3, text: "Consumidor" },
          { value: 4, text: "Criminal" },
          { value: 5, text: "Violência Doméstica" },
          { value: 6, text: "Moradia" },
          { value: 7, text: "Saúde" },
          { value: 8, text: "Criança e Adolescente" },
          { value: 9, text: "Outros" },
        ];
      });
    },
    aplicarCor() {
      this.$nextTick(() => {
        const header = document.querySelector('#modal-manifestacao-form .modal-header');
        if (header) header.style.backgroundColor = this.cor;
      });
    },
    Iniciar() {
      this.etapa = (this.inttipomanifestacaoid === 6) ? 2 : 1;
      this.enviando = false;
      this.form = {
        strnome: null,
        strnomesocial: null,
        stremail: null,
        strcpf: null,
        strcelular: null,
        intestadoid: null,
        intcidadeid: null,
        inttipomanifestanteid: null,
        inttipomanifestacaoid: this.inttipomanifestacaoid,
        inttipoalvoid: null,
        intassuntomanifestacaoid: null,
        strdenuncia: null,
      };
      this.lista_cidade = [{ value: null, text: "Selecione o estado primeiro" }];
      this.ListaEstado();
      this.ListaTipoManifestante();
      this.ListaTipoAlvo();
      this.ListaAssunto();
    },
  },
};
</script>

<style>
#modal-manifestacao-form .modal-header {
  color: white !important;
}
#modal-manifestacao-form .modal-footer {
  justify-content: flex-start !important;
  background-color: #ececec !important;
}
</style>
